import React from 'react';
import {useSelector} from 'react-redux';
import {Alert, Image, ScrollView, TouchableOpacity, View} from 'react-native';
import moment from 'moment';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

/////////////////////////////////////////////
///////  utils
import {formatNumberDisplayAmount} from 'src/Utils/formatHelper';
import {apiTrackUserTransaction} from 'src/Utils/apiCalls';
import {setDataAtPath, updateDataAtPath} from 'src/Utils/fireUtils';

/////////////////////////////////////////////
///////  components
import UserProfileIcon from 'src/Modules/UserProfileIcon';
import {BodyText, DealCard} from 'src/Modules/CommonView';

import JoinVoucherSearch from '../JoinRedeem/JoinVoucherSearch';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {useExplorerPass} from '../Utils/explorerPassHelper';
import {useUserId, useUserInfo} from 'src/Hooks/reduxHooks';
import {cloudFlareOptimizeImage} from '../Utils/helpers';
import {redeemCoinsForTicket} from '../Utils/huntFunctions';

const memberImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577715_large.jpg',
  ),
};
// single coin with fox in profile direction
const coinImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648581485_original.png',
  ),
};
const redeemImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577343_medium.jpg',
  ),
};

const thirdPartyImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577604_medium.jpg',
  ),
};

const passImageFamily = require('src/Images/Passes/FamilyPass.png');
const passImageDate = require('src/Images/Passes/DatePass.png');

const Shop = ({navigateToPage}) => {
  const themeInfo = useSelector((state) => state.themeInfo);
  const location = useSelector((state) => state.location);
  const ticket_vouchers = useSelector((state) => state.ticket_vouchers);

  const {themes, themesList} = themeInfo;

  return (
    <ScrollView>
      <UserInventorySection
        navigateToPage={navigateToPage}
        themeInfo={themeInfo}
      />
      <DiningSection location={location} />
      {/* <CoinsSection /> */}
      <PurchaseSection themesList={themesList} themes={themes} />
      <RedeemSection />

      <PurchaseSection themesList={themesList} themes={themes} redeem />

      <JoinVoucherSearch
        background={global?.color?.white}
        ticket_vouchers={ticket_vouchers}
        handlePress={(code) => {
          navigationRef.navigate('JoinHuntModal', {
            voucherCode: code,
            autoSubmit: true,
          });
        }}
      />
      <View style={{height: 120}} />
    </ScrollView>
  );
};

const UserInventorySection = ({themeInfo, navigateToPage}) => {
  const coins = useUserInfo('coins');
  const {width} = useWindowDimensionsSafe();
  const userId = useUserId();

  const handleTicketsToCoins = (theme, number) => {
    const {themes} = themeInfo;

    Alert.alert(
      'Do you want to refund these tickets back to coins?',
      'You can use these coins to exchange for other tickets types.',
      [
        {
          text: 'Cancel',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        {
          text: 'Confirm',
          onPress: () => {
            const coinsValue = number * themes[theme].coin_price;
            setDataAtPath(`users/${userId}/tickets/${theme}`, null);
            updateDataAtPath(`users/${userId}/coins`, coins + coinsValue);

            // track ticket to coin exchange
            apiTrackUserTransaction({
              type: 'tickets_for_coins',
              user_id: userId,
              usage_user_id: userId,
              coins: coinsValue,
              tickets: -number,
              theme,
            });
          },
        },
      ],
      {cancelable: false},
    );
  };

  const getPassImage = (passType = '') => {
    if (passType?.includes?.('Couple')) {
      return passImageDate;
    }
    if (passType?.includes?.('Family')) {
      return passImageFamily;
    }
    return passImageFamily;
  };

  const {themes} = themeInfo;

  const tickets = useUserInfo('tickets');

  const pass = useExplorerPass();

  const {passType, passPlayers} = pass || {};

  const displayedCoins = formatNumberDisplayAmount(coins);

  const userTickets = Object.keys(tickets || {})
    ? Object.keys(tickets || {})
        ?.map?.((key) => {
          return {type: key, amount: tickets?.[key]};
        })
        .filter((item) => themes[item.type] && item.amount > 0)
    : [];

  return (
    <SectionContainer>
      <TouchableOpacity
        style={{
          alignItems: 'center',
          paddingVertical: 10,
          borderBottomColor: global?.color?.white1,
          borderBottomWidth: 2,
          marginHorizontal: 10,
          position: 'relative',
        }}
        onPress={() => navigateToPage('profile')}
        activeOpacity={0.8}>
        <UserProfileIcon showName textColor={global?.color?.gray3} />
      </TouchableOpacity>
      <View
        style={{
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginHorizontal: 10,
          minHeight: 40,
          width: width - 40,
        }}>
        <BodyText text={'Coins'} textStyle={{marginTop: 5}} />
        <View
          style={{
            alignItems: 'center',
            flexDirection: 'row',
          }}>
          <BodyText
            text={displayedCoins}
            textStyle={{marginTop: 5, marginRight: 2}}
          />
          {!!coins && (
            <Image
              style={{
                height: 28,
                width: 28,
                marginHorizontal: 2,
                resizeMode: 'contain',
              }}
              source={coinImage}
            />
          )}
        </View>
      </View>
      {!!pass && (
        <View
          style={{
            borderTopColor: global?.color?.white1,
            borderTopWidth: 2,
            marginHorizontal: 10,
            marginBottom: 10,
          }}
        />
      )}
      {!!pass && (
        <View
          style={{
            flexDirection: 'row',
            width: width - 10,
            marginHorizontal: 5,
            marginBottom: !!userTickets?.length ? 10 : 0,
          }}>
          <TicketOptionTile
            currentTickets={`${passPlayers || 2}x Players`}
            color={global?.color?.teal}
            hideX
            handlePress={() => {
              navigationRef.navigate('ConfirmModal', {
                titleText: `How To Use Your ${passType}`,
                confirmText: 'Got It!',
                cancelText: 'See Hunts',
                handleConfirm: () => {
                  navigationRef.goBack(null);
                },
                handleCancel: () => {
                  navigationRef.goBack(null);
                  navigationRef.navigate('LandingPageMain', null, 'Shop');
                },
                children: (
                  <View>
                    <BodyText
                      textStyle={{paddingLeft: 10}}
                      text={`\u2022 Valid for up to ${passPlayers} players per group.`}
                    />
                    <BodyText
                      textStyle={{paddingLeft: 10}}
                      text={`\u2022 When you want to start a hunt, select a scavenger hunt, bar hunt, ghost tour, or other activity from the app home screen.`}
                    />
                    <BodyText
                      textStyle={{paddingLeft: 10}}
                      text={`\u2022 Your explorer pass will work for any activity, except for Bachelorette Parties.`}
                    />
                    <BodyText
                      textStyle={{paddingLeft: 10}}
                      text={`\u2022 Create a group and use the join code to add other players to your device or share the join code with your group so they can play on their own device (you can also do this via QR Code).`}
                    />
                    <BodyText
                      textStyle={{paddingLeft: 10}}
                      text={`\u2022 Have fun exploring your city! It's always best to start with a full battery, good walking shoes, and plenty of water.`}
                    />
                  </View>
                ),
              });
            }}
            itemWidth={width / 2 - 20}
            imageSource={getPassImage(passType)}
            imageLabel={'Explorer Pass'}
          />
          <View
            style={{
              width: width / 2 - 20,
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              paddingLeft: 10,
              paddingRight: 15,
            }}>
            <BodyText text={passType || 'Explorer Pass'} />
          </View>
        </View>
      )}
      {!!userTickets?.length && (
        <View
          style={{
            borderTopColor: global?.color?.white1,
            borderTopWidth: 2,
            marginHorizontal: 10,
            marginBottom: 10,
          }}
        />
      )}
      {!!userTickets?.length && (
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: width - 10,
            marginHorizontal: 5,
          }}>
          {!!userTickets &&
            userTickets?.map?.((item) => {
              const {type, amount} = item;
              return (
                <TicketOptionTile
                  key={`${type}_${Date.now() * Math?.random()}`}
                  theme={themes[type]}
                  handlePress={() => handleTicketsToCoins(type, amount)}
                  currentTickets={`${formatNumberDisplayAmount(
                    amount,
                  )}x Ticket(s)`}
                  color={global?.color?.orange}
                />
              );
            })}
        </View>
      )}
    </SectionContainer>
  );
};

const PurchaseSection = ({themesList, themes, redeem = false}) => {
  const {width} = useWindowDimensionsSafe();
  console.log({themesList});
  const coins = useUserInfo('coins');
  return (
    <SectionContainer>
      <BodyText
        text={redeem ? 'Use Bonus Coins To Get Tickets' : 'Purchase Tickets'}
        textStyle={{marginLeft: 10, fontWeight: '700'}}
      />
      {!!redeem && (
        <BodyText
          text={`Earn coins through the completion of hunts, acquisition of badges, participation in daily challenges, and various other activities. On average, successfully finishing three hunts will provide you with ample coins to redeem a ticket.`}
          textStyle={{marginLeft: 10, fontSize: 12, marginBottom: 20}}
        />
      )}
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          width: width - 10,
          marginHorizontal: 5,
        }}>
        {!!themesList &&
          themesList
            ?.filter(
              (theme) =>
                theme != 'Bachelorette' &&
                theme != 'Birthday' &&
                theme != 'Bachelor' &&
                theme != 'In-Home',
            )
            .map?.((key) => {
              const theme = themes[key];
              const {coin_price} = theme || {};
              return (
                <TicketOptionTile
                  key={`${key}_${Date.now()}`}
                  theme={theme}
                  redeem={redeem}
                  handlePress={() => {
                    if (redeem) {
                      if (coins >= coin_price) {
                        return navigationRef.navigate('ConfirmModal', {
                          titleText: 'Do You Want To Redeem Your Coins',
                          titleBodyText: `Use ${coin_price} coins to get 1 ${key} ticket.`,
                          cancelText: 'Later',
                          confirmText: 'Redeem',
                          handleConfirm: (handleDone) => {
                            handleDone();
                            redeemCoinsForTicket(coin_price, key);
                          },
                        });
                      } else {
                        return navigationRef.navigate('ConfirmModal', {
                          titleText: 'You Do Not Have Enough Bonus Coins',
                          titleBodyText:
                            'Earn bonus coins by doing hunts and daily challenges. On average you will earn 1 ticket per 3 hunts that you do.',
                          cancelText: 'Okay',
                          confirmText: 'Buy Tickets Instead',
                          handleConfirm: (handleDone) => {
                            handleDone();
                            navigationRef.navigate('PurchaseModal', {
                              forcedTheme: key,
                            });
                          },
                        });
                      }
                    }
                    navigationRef.navigate('PurchaseModal', {
                      forcedTheme: key,
                    });
                  }}
                />
              );
            })}
      </View>
    </SectionContainer>
  );
};

const TicketOptionTile = ({
  handlePress,
  imageSource,
  imageLabel,
  theme = {},
  currentTickets,
  hideX,
  color = global?.color?.teal,
  itemWidth,
  redeem = false,
}) => {
  const {
    coin_price = 0,
    dollar_price = '$11.99',
    text = '',
    icon_source,
  } = theme;
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      style={{
        backgroundColor: global?.color?.white1,
        borderRadius: 10,
        marginHorizontal: 5,
        marginVertical: 5,
        position: 'relative',
        width: itemWidth || (width - 60) / 3,
      }}
      activeOpacity={0.9}
      disabled={!handlePress}
      onPress={handlePress}>
      <View
        style={{
          alignItems: 'center',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          height: 80,
          justifyContent: 'flex-end',
        }}>
        {!!imageSource && (
          <Image
            style={{
              width: (itemWidth || (width - 60) / 3) - 10,
              maxHeight: 70,
              height: 70,
              resizeMode: 'contain',
            }}
            source={imageSource}
          />
        )}
        {!!icon_source && (
          <Image
            style={{
              width: (itemWidth || (width - 60) / 3) - 10,
              maxHeight: 70,
              height: 70,
              resizeMode: 'contain',
            }}
            source={{uri: icon_source}}
          />
        )}
      </View>
      <BodyText
        text={imageLabel || text}
        textStyle={{
          fontSize: 12,
          marginTop: 3,
          marginBottom: 3,
          textAlign: 'center',
        }}
      />
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: color,
          flexDirection: 'row',
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}>
        <BodyText
          text={
            redeem
              ? currentTickets || coin_price?.toLocaleString?.() || 0
              : `$${dollar_price} / Player`
          }
          textStyle={{
            fontSize: 12,
            marginTop: 3,
            marginBottom: 3,
            marginRight: !!currentTickets ? 10 : 0,
            color: global?.color?.white,
          }}
        />
        {!currentTickets && !!redeem && (
          <Image
            style={{
              height: 12,
              width: 12,
              marginHorizontal: 2,
              resizeMode: 'contain',
            }}
            source={coinImage}
          />
        )}
      </View>
      {!!currentTickets && !hideX && (
        <BodyText
          text={'x'}
          textStyle={{
            fontSize: 16,
            position: 'absolute',
            top: -5,
            width: 20,
            height: 20,
            right: -20,
          }}
        />
      )}
    </TouchableOpacity>
  );
};

const DiningSection = () => {
  const pass = useExplorerPass();
  const activePassportSubscriptionId = useUserInfo(
    'activePassportSubscriptionId',
  );
  let hasValidExplorerPass = !!pass;

  let headerText = hasValidExplorerPass
    ? `Edit your Let's Roam Membership`
    : `Get a Let's Roam Membership`;

  let passExpirationText = '';
  if (pass && !pass.isSubscription && pass.expiresDate) {
    passExpirationText = ` Valid Until ${moment(pass.expiresDate).format(
      'MMM-DD-YYYY',
    )}`;
  }

  return (
    <View style={{marginTop: 10}}>
      <DealCard
        topTitle={headerText + passExpirationText}
        imageSource={memberImage}
        title={`Save Big`}
        description={`With a single Explorer get unlimited adventures for you and all your friends.`}
        handlePress={() => {
          if (hasValidExplorerPass && !activePassportSubscriptionId) {
            return Alert.alert(
              'You have a Valid Membership',
              `Your pass is valid until ${moment(pass.expiresDate).format(
                'MMM-DD-YYYY',
              )} and will not renew automatically.`,
            );
          }
          hasValidExplorerPass
            ? navigationRef.navigate(
                'Please call support at 1-833-202-7626 to change your membership.',
              )
            : navigationRef.navigate('ExplorerPassSubscriptionsListModal');
        }}
        containerStyle={{minHeight: 190}}
      />
    </View>
  );
};

const RedeemSection = () => {
  return (
    <View style={{marginTop: 10}}>
      <BodyText
        text={'Redeem A Voucher'}
        textStyle={{marginLeft: 10, fontWeight: '700'}}
      />
      <DealCard
        imageSource={redeemImage}
        handlePress={() => navigationRef.navigate('JoinHuntModal')}
        title={'Website Vouchers & Promo Codes'}
        description={`Redeem Let's Roam & Scavengerhunt.com vouchers`}
      />
      <DealCard
        imageSource={thirdPartyImage}
        handlePress={() => navigationRef.navigate('GrouponRedemption')}
        title={'3rd Party Vouchers'}
        description={`Redeem Groupon and other 3rd party vouchers`}
        testID={'grouponButton'}
      />
    </View>
  );
};

const SectionContainer = ({children, handlePress}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      style={{
        backgroundColor: global?.color?.white,
        borderRadius: 10,
        marginHorizontal: 10,
        marginVertical: 10,
        paddingVertical: 5,
        position: 'relative',
        width: width - 20,
      }}
      onPress={handlePress}
      disabled={!handlePress}
      activeOpacity={0.8}>
      {children}
    </TouchableOpacity>
  );
};

export default Shop;
